import React from 'react';
import { CdnImage } from 'src/components/cdn-image';
import { FontEmphasis } from '@prisjakt/ui/text/variants';

import * as S from './styles';

export { DEFAULT_STORE_LOGO_MAX_WIDTH, StoreLogoVariant } from './styles';

type Props = {
  className?: string;
  featured?: boolean;
  hasImage: boolean;
  logoUrl?: string | null;
  name: string;
  showHighResolutionLogo?: boolean; // Making image half the size
  storeId: number | string;
  variant?: S.StoreLogoVariant;
  width?: number;
};

export const StoreLogo = ({
  className,
  featured = false,
  hasImage,
  logoUrl,
  name,
  showHighResolutionLogo = false,
  storeId,
  variant = S.StoreLogoVariant.DEFAULT,
  width = 88,
}: Props) => {
  const shouldRenderLogo =
    hasImage && (featured || variant === S.StoreLogoVariant.CAMPAIGN);

  return (
    <S.StoreLogo
      className={className}
      logoWidth={width}
      showHighResolutionLogo={showHighResolutionLogo}
      showLogo={shouldRenderLogo}
      variant={variant}
    >
      {shouldRenderLogo ? (
        <CdnImage name={storeId} width={width} alt={name} logoUrl={logoUrl} />
      ) : (
        <S.StoreLogoText emphasis={FontEmphasis.LOW}>{name}</S.StoreLogoText>
      )}
    </S.StoreLogo>
  );
};
